import { createI18n } from "vue-i18n";
import en from "../locales/en.json";
import ro from "../locales/ro.json";
import ru from "../locales/ru.json";
import { detectInitialLocale, ensureSupportedLocale } from "../Utile/i18n.js";

export const messages = {
  en,
  ro,
  ru,
};

export const availableLocales = [
  { code: "ro", label: "Română" },
  { code: "en", label: "English" },
  { code: "ru", label: "Русский" },
];

const missing = (locale, key) => {
  console.warn(`[i18n] missing translation for key "${key}" in locale "${locale}"`);
};

export function createI18nInstance() {
  const initialLocale = ensureSupportedLocale(detectInitialLocale());

  return createI18n({
    legacy: false,
    globalInjection: true,
    locale: initialLocale,
    fallbackLocale: false,
    messages,
    missing,
  });
}
